import React, { useState, useContext } from 'react';
import styled from 'styled-components';

import { Tooltip as ReactTooltip } from 'react-tooltip';

import FieldToolTipIcon from '../icons/FieldToolTipIcon';

import ThemeContext from '../../theme/ThemeContext';

const StyledTooltipContainer = styled.div``;

const StyledTooltipContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  font-family: ${(props) => props.theme.fontFamily};
`;

const StyledTooltipTitle = styled.span`
  width: 100%;
  height: 100%;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  overflow-wrap: break-word;
  margin-bottom: 5px;
  text-align: left;
`;

const StyledTooltipDescription = styled.span`
  font-weight: 400px;
  font-size: 12px;
  line-height: 15px;
  overflow-wrap: break-word;
  text-align: left;
`;

/**
 * <----------NOTICE--------------->
 * We use a package called react-tooltip for displaying tooltips
 * Tooltips library link - https://github.com/ReactTooltip/react-tooltip/
 * npm link - https://www.npmjs.com/package/react-tooltip
 *
 */
const Tooltip = ({ tipVisible, title, description, fieldId }) => {

  const theme = useContext(ThemeContext);

  const [displayTip, setDisplayTip] = useState(false);

  const tooltipIconNode = tipVisible ? <FieldToolTipIcon data-tooltip-id={`${fieldId}field-tootlip`} /> : null;

  const toolTipContentNode = (
    <StyledTooltipContentWrapper>
      <StyledTooltipTitle>{title}</StyledTooltipTitle>
      <StyledTooltipDescription>{description}</StyledTooltipDescription>
    </StyledTooltipContentWrapper>
  );

  return (
    <StyledTooltipContainer
      theme={theme}
      onMouseEnter={() => setDisplayTip(true)}
      onMouseLeave={() => setDisplayTip(false)}
    >
      {tooltipIconNode}
      <ReactTooltip
        id={`${fieldId}field-tootlip`}
        hidden={!displayTip}
        opacity={1}
        style={
          {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            maxWidth: '350px',
            color: 'black',
            padding: '10px',
            borderRadius: '5px',
            boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.5)',
            fontSize: '12px',
            lineHeight: '15px',
            textAlign: 'left',
            zIndex: '999999999999',
          }
        }
      >
        {toolTipContentNode}
      </ReactTooltip>
    </StyledTooltipContainer>
  );
};

export default Tooltip;
